const hamburger = {
    init: () => {
        const hamburger = document.querySelector('.top-nav__hamburger');
        const nav = document.querySelector('.top-nav__navigation');
        const navItems = document.querySelectorAll('.top-nav .menu-item');

        const handleClick = () => {
            hamburger.classList.toggle('top-nav__hamburger--active');
            nav.classList.toggle('top-nav__navigation--active');
        }

        hamburger.addEventListener('click', handleClick);

        const handleNavClosing = () => {
            navItems.forEach(navItem => {
                navItem.addEventListener('click', () => {
                    hamburger.classList.remove('top-nav__hamburger--active');
                    nav.classList.remove('top-nav__navigation--active');
                });
            });
        }

        handleNavClosing();

        window.addEventListener('resize', () => {
            if (window.innerWidth < 1024) {
                handleNavClosing();
            }
        });
    }
}

export default hamburger;